<template>
    <div class="dialog">
        <td-dialog :title="$t(title)" :before-close="dlalogClose" :visible.sync="modifyDeviceAvailable" :close-on-click-modal="false" :close-on-press-escape="false" :width="modifyDialogWidth + 'px'">
            <div>
                <el-tabs v-if="this.isDetailsInfo ? false : true" class="paddingTop20" v-model="editableTabsValue" type="card" @tab-click="changePane">
                    <el-tab-pane class=".el-tabs__header" v-for="item in editableTabs" :key="item.name" :label="$t(item.title)" :name="item.name"> </el-tab-pane>
                </el-tabs>
                <keep-alive>
                    <component
                        v-bind:is="currentTabComponent"
                        :isShowDeviceLable="isShowDeviceLable"
                        @dlalogClose="dlalogClose"
                        :iDeviceTypes="iDeviceTypes"
                        :editItem="editItem"
                        :orgInfo="orgInfo"
                        :isAddData="isAddData"
                        :devDisplay="devDisplay"
                        :nameDisplay="nameDisplay"
                        :ipTypeDisplay="ipTypeDisplay"
                        :ipDisplay="ipDisplay"
                        :iPSegmentDisplay="iPSegmentDisplay"
                        :portDisplay="portDisplay"
                        :isOrgDevTree="isOrgDevTree"
                        :descriptionDisplay="descriptionDisplay"
                        :masterServeDisplay="masterServeDisplay"
                        :domainTypeDisplay="domainTypeDisplay"
                        :deviceLable="deviceLable"
                        :parentDevLable="parentDevLable"
                        :isbelongOrgDisplay="isbelongOrgDisplay"
                        :belongDevDisabled="belongDevDisabled"
                        :portLable="portLable"
                        :extendGroupFlg="extendGroupFlg"
                        :parentDevType="parentDevType"
                        :belongDevRequired="belongDevRequired"
                        :regularCheckID="regularCheckID"
                        :spanNum="spanNum"
                        ref="modifyDevice"
                        @submit="submit"
                        @belongDevChange="belongDevChange"
                        @setSubmitDevType="setSubmitDevType"
                        @handleExtendDataMethod="handleExtendDataMethod"
                        @handleDataMethod="handleDataMethod"
                        @change="change"
                        :isHandleExtendData="isHandleExtendData"
                        :isHandleData="isHandleData"
                        :isCloseDialog="isCloseDialog"
                        :downloadSettingsTip="downloadSettingsTip"
                        :diySuccessMessage="diySuccessMessage"
                        :saveBtnDisplay="currentSaveBtnDisplay"
                        :devIdReadOnly="devIdReadOnly"
                        :devInfoFormLabelWidth="modifyDevInfoFormLabelWidth"
                        :beforeSubmitForm="beforeSubmitForm"
                        :nameLable="nameLable"
                        :ipDisabled="ipDisabled"
                        :customNameRegex="customNameRegex"
                        :isEnablePromptInformation="isEnablePromptInformation"
                        :promptCode="promptCode"
                    >
                    </component>
                </keep-alive>
            </div>
            <span slot="footer"> </span>
        </td-dialog>
    </div>
</template>
<script>
export default {
    name: 'tableIndex',
    props: {
        // 设备Id是否显示
        isShowDeviceLable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 编辑时，表单域标签的宽度设置 */
        modifyDevInfoFormLabelWidth: {
            type: [Number, String],
            default: function() {
                return 110;
            }
        },
        /* 编辑dialog宽度设置 */
        modifyDialogWidth: {
            type: [Number, String],
            default: function() {
                return 800;
            }
        },
        title: {
            type: [String, Number]
        },
        modifyDeviceAvailable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        editItem: {
            trpe: Object,
            default: function() {
                return null;
            }
        },
        editableTabs: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 所属设备是否显示
        devDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 名称是否显示
        nameDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //ip类型是否显示
        ipTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // IP是否显示
        ipDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 端口是否显示
        portDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 顶级中间件是否显示
        masterServeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 域类型是否显示
        domainTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 描述是否显示
        descriptionDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //所属设备是否为组织设备树
        isOrgDevTree: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 每行显示列数
        spanNum: {
            type: Number,
            default: function() {
                return 12;
            }
        },
        parentDevType: {
            type: Array,
            default: function() {
                return [];
            }
        },
        //所属设备名称
        parentDevLable: {
            type: String,
            default: function() {
                return 'common.BELONGED_DEVICE';
            }
        },
        // 所属设备是否可编辑
        belongDevDisabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 所属组织是否禁用
        isbelongOrgDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        isAddData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        deviceLable: {
            type: String
        },
        portLable: {
            type: String
        },
        orgInfo: {
            type: Object,
            default: function() {
                return null;
            }
        },
        //扩展组标识
        extendGroupFlg: {
            type: String
        },
        //IP段是否显示
        iPSegmentDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //所属设备是否必填
        belongDevRequired: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 设备ID是否进行正则校验
        regularCheckID: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备ID是否只读
        devIdReadOnly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存时是否处理扩展元素数据
        isHandleExtendData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存时是否处理表单元素数据
        isHandleData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存后，是否触发关闭dialog方法
        isCloseDialog: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 是否显示详细信息
        isDetailsInfo: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //表单提交前触发的方法
        beforeSubmitForm: Function,
        // 是否提示所属设备已修改，请下传设置
        downloadSettingsTip: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 自定义提示信息
        diySuccessMessage: {
            type: String
        },
        //label名称
        nameLable: {
            type: String,
            default: function() {
                return 'common.NAME';
            }
        },
        //ip是否可编辑
        ipDisabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否启用设备名称自定义校验正则表达式
        customNameRegex: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否启用回调提示信息自定义等级
        isEnablePromptInformation: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //提示信息内容(状态码，等级)
        promptCode: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },

    data() {
        return {
            paneName: '',
            hight: 100,
            orgChange: false,
            currentSaveBtnDisplay: this.isDetailsInfo ? false : true
        };
    },
    created() {
        if (this.paneName === '') {
            this.editableTabsValue = this.editableTabs[0].name;
        }
    },

    computed: {
        // currentTabComponent: function() {
        //     // 路径不支持动态
        //     if (this.paneName === '') {
        //         return () => import(`@/modules/device/tabs/${this.editableTabs[0].name}`);
        //     }
        //     return () => import(`@/modules/device/tabs/${this.paneName}`);
        // }
        currentTabComponent: function() {
            // 路径不支持动态
            if (this.paneName === '') {
                return this.editableTabs[0].name;
            }
            return this.paneName;
        }
    },
    methods: {
        // 关闭窗口之前需要调用的方法
        dlalogClose() {
            this.$log.info('dlalogClose');
            this.$emit('dlalogClose');
            if (this.orgChange) {
                this.$emit('submit');
            }
        },
        submit() {
            this.$emit('submit');
        },
        //设置提交保存的设备类型
        setSubmitDevType(submitDevType, callback) {
            this.$emit('setSubmitDevType', submitDevType, function(type) {
                callback(type);
            });
        },
        //保存时是否处理扩展元素数据
        handleExtendDataMethod(extendData, callback) {
            this.$emit('handleExtendDataMethod', extendData, function(data) {
                callback(data);
            });
        },
        //保存时是否处理表单数据
        handleDataMethod(content, callback) {
            this.$emit('handleDataMethod', content, function(data) {
                callback(data);
            });
        },
        // 所属设备change事件
        belongDevChange(value) {
            this.$emit('belongDevChange', value);
        },
        change(flag) {
            this.orgChange = flag;
        },
        changePane(pane) {
            this.paneName = pane.name;
            this.$emit('changePane', pane);
        }
    }
};
</script>

<style scoped>
>>> .el-tabs__header {
    margin-bottom: 0px;
}
.dialog >>> .el-dialog__body {
    padding-right: 0;
}
.dialog >>> .el-dialog {
    margin-top: 8vh !important;
}
</style>
